import VueScrollTo from "vue-scrollto";

export const minxin = {
    data() {
        return {
            scrollOptions: null,
        };
    },
    created() {
        this.scrollOptions = {
            container: "body",
            easing: "ease",
            lazy: false,
            offset: 0,
            force: true,
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false,
            x: false,
            y: true
        }
    },
    components: {},
    computed: {},
    mounted() {
    },
    methods: {
        navTo(currentPage, targetPage, scrollElement, currentLang) {
            const that = this;
            console.log('navTo: currentPage = ' + currentPage + ', targetPage = ' + targetPage
                + ', scrollElement = ' + scrollElement + ', currentLang = ' + currentLang);

            if (currentPage === targetPage) {
                VueScrollTo.scrollTo(scrollElement, 500, that.scrollOptions);
            } else {
                if ('cn' === currentLang) {
                    currentLang = '/' + currentLang + '/';
                } else {
                    currentLang = '/'
                }
                window.location.href = currentLang + targetPage + scrollElement;
            }
        },
        scrollOnLoad() {
            const that = this;
            const hash = window.location.hash;
            const currentPath = window.location.pathname;
            console.log(hash);
            console.log(currentPath);
            if ((null !== currentPath && undefined !== currentPath)
                && (currentPath.startsWith('/home') || currentPath.startsWith('/cn/home'))) {
                const splits = hash.split('#');
                console.log(splits);

                if (splits.length > 1 && ('products' === splits[1] || 'contact' === splits[1])) {
                    VueScrollTo.scrollTo('#' + splits[1], 500, that.scrollOptions);
                }
            }
        },
    },
    destroyed() {
    }
};
